import { Component } from '@angular/core';
import { CommonDataService } from './shared/services/common-data.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderService } from './common/header/header.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = "ITI Mutual Fund";
  breadCrumbs: any = {};
  loaderStatus = false;
  pagePathURL!: string

  constructor(
    public commonDataService: CommonDataService,
    router: Router,
    public route: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title,
    private headerService: HeaderService) {
    this.commonDataService.loaderStatus.asObservable().subscribe((data) => {
      setTimeout(() => {
        this.loaderStatus = data;
      }, 10);
    });

    router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .forEach((e: NavigationEnd) => {
          this.breadCrumbs = route.root.firstChild.snapshot.data;
          this.setMetaTag();
          this.headerService.isSocialShareChange.emit( e.url && ( e.url !== '/home' && e.url !== '/'))
          this.pagePathURL = e.url;
        this.commonDataService.setSubBreadCrumb(null);
        });
  }

  ngOnInit() {

  }

  public setMetaTag() {
    if (this.breadCrumbs.title) {
      this.titleService.setTitle(this.breadCrumbs.title);
    }

    if (this.breadCrumbs.meta) {
      this.metaService.updateTag({
        name: "description",
        content: this.breadCrumbs.meta,
      });
    }

    if (this.breadCrumbs.keywords) {
      this.metaService.updateTag({
        name: "keywords",
        content: this.breadCrumbs.keywords,
      });
    }
  };
  
}
